const isNegativeInfinity = (x) => x === Number.NEGATIVE_INFINITY;
export default isNegativeInfinity;
